var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activity-content auto-rebalance-disabled" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "activity-details" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "detail-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("Son Hata:")]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.activity.payload.error)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "detail-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("Başarısız Deneme:")]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(
              _vm._s(_vm.activity.payload.failedAttempts) +
                "/" +
                _vm._s(_vm.activity.payload.maxFailedAttempts)
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "detail-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("Eşik Değer:")]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(
              _vm._s(_vm.formatPrice(_vm.activity.payload.threshold)) + " TL"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "detail-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("Hedef Bakiye:")]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.formatPrice(_vm.activity.payload.upTo)) + " TL"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(2),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "activity-header" }, [
      _c("span", { staticClass: "material-icons disabled-icon" }, [
        _vm._v("block"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "activity-title" }, [
        _vm._v("Otomatik Bakiye Yükleme Devre Dışı"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-item" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Sebep:")]),
      _vm._v(" "),
      _c("span", { staticClass: "value error" }, [
        _vm._v("Çok fazla başarısız deneme"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "activity-footer" }, [
      _c("span", { staticClass: "critical-text" }, [
        _c("span", { staticClass: "material-icons" }, [_vm._v("warning")]),
        _vm._v(
          "\n            Otomatik yükleme özelliği devre dışı bırakıldı. Panel ayarlarından kontrol edin ve yeniden etkinleştirin.\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }